<template lang="pug">
.envelope-viewer--screen(v-if='isReady')
  .row(:class='{ blured: blured }')
    .col-12.col-lg-9.viewer
      .documents-section-title(v-if='payload.envelope.documents.length > 1')
        span.text {{ $t('modal.envelope.documents', { total: payload.envelope.documents.length }) }}
        icon.fs-6(
          name='circle-question'
          v-tooltip:top='$t("modal.envelope.documentsInfoHint", { total: payload.envelope.documents.length })'
        )
      document-badge-selector(
        :documents='payload.envelope.documents'
        :selected-document='currentDocument'
        @select='currentDocument = $event'
      )
      documents-viewer(
        :document='currentDocument'
        :documents='payload.envelope.documents'
        :envelope='payload.envelope'
        :recipient-id='payload.id'
        @document-selected='currentDocument = $event'
        @element-updated='onElementUpdate'
        @empty-fields='emptyFields = $event'
        @loaded='documentLoaded = $event'
        @signature-updated='onSignatureUpdate'
        hide-selector
      )
    .col-12.col-lg-3.recipients-list
      signatures-summary-badge.mb-3(
        :count='mySignaturesSummary.count'
        :total='mySignaturesSummary.total'
        personal
        v-if='mySignaturesSummary'
      )
      signatures-list-dropdown(
        :current-document='currentDocument'
        :envelope='payload.envelope'
      )
    .col-12.actions-bar.my-3(:class='{ loaded: documentLoaded }')
      bottom-action(
        :disableOptions='!isAllowed || emptyFields.length > 0'
        :payload='payload'
        @canceled='canceled'
        @fetchEnvelope='fetchEnvelope'
        @rejected='rejected'
        @signatureFailure='signatureFailure'
        @signaturePdfAWhenAlreadySignedDocumentsFailure='signaturePdfAWhenAlreadySignedDocumentsFailure'
        @signed='signed'
        @unableEnvelopeFurtherActions='unableEnvelopeFurtherActions'
        ref='bottomAction'
        v-if='userCanSing || userCanApprove || userIsViewer'
      )
  show-envelope-info-modal(
    :addressee='addressee'
    :canViewEnvelope='canActionEnvelope'
    :envelope='payload.envelope'
    :hideFormAcceptTerms='hideFormAcceptTerms'
    :isPublic='isPublic'
    :recipientType='payload.type'
    @closed='checkIfIsAllowed'
    @process='markAsAllowed'
    ref='showEnvelopeInfoModal'
  )
  show-envelope-done-modal(
    :envelopeId='payload.envelope.id'
    :is-public='isPublic'
    ref='showEnvelopeDoneModal'
  )
  show-envelope-signer-done-modal(
    :envelopeId='payload.envelope.id'
    :is-public='isPublic'
    ref='showEnvelopeSignerDoneModal'
  )
  show-signature-failure-modal(ref='showSignatureFailureModal')
  show-signature-pdf-a-when-already-signed-documents-failure-modal(
    ref='showSignaturePdfAWhenAlreadySignedDocumentsFailureModal'
  )
  show-unable-envelope-further-actions-modal(
    :envelope-status='payload.envelope.state'
    ref='ShowUnableEnvelopeFurtherActionsModal'
  )
  approve-envelope-modal(
    :is-public='isPublic'
    :subject='payload.envelope.subject'
    ref='approveEnvelopeModal'
  )
  approve-envelope-done-modal(
    :is-public='isPublic'
    :subject='payload.envelope.subject'
    ref='approveEnvelopeDoneModal'
  )
  show-request-signature-sent-modal(
    :is-public='isPublic'
    ref='showRequestSignatureSentModal'
  )
</template>
<script>
import RecipientsService from '@/modules/business/services/http/envelopes/RecipientsService';
import SignatureHttp from '@/services/SignatureHttp';
import DocumentsViewer from '@/ui/organisms/DocumentsPDFViewer.vue';
import EnvelopeManager from '@/modules/business/services/EnvelopeManager';
import ShowEnvelopeInfoModal from '@/modules/business/components/organisms/modals/ShowEnvelopeInfoModal.vue';
import ShowEnvelopeDoneModal from '@/modules/business/components/organisms/modals/ShowEnvelopeDoneModal.vue';
import ShowEnvelopeSignerDoneModal from '@/modules/business/components/organisms/modals/ShowEnvelopeSignerDoneModal.vue';
import BottomAction from '@/ui/organisms/DocumentsBottom.vue';
import Icon from '@/ui/atoms/Icon.vue';
import EnvelopeState from '@/enums/EnvelopeState';
import RecipientState from '@/enums/RecipientState';
import RecipientType from '@/enums/RecipientType';
import ShowSignatureFailureModal from '@/modules/business/components/organisms/modals/ShowSignatureFailureModal.vue';
// eslint-disable-next-line max-len
import ShowRequestSignatureSentModal from '@/modules/business/components/organisms/modals/RequestSignatureSentModal.vue';
import ApproveEnvelopeModal from '@/modules/business/components/organisms/modals/ApproveEnvelopeModal.vue';
import ApproveEnvelopeDoneModal from '@/modules/business/components/organisms/modals/ApproveEnvelopeDoneModal.vue';
import SignaturesListDropdown from '@/modules/business/components/organisms/SignatureListAccordion.vue';
import alert from '@/modules/account/common/alert';
import ShowUnableEnvelopeFurtherActionsModal from '@/modules/business/components/organisms/modals/ShowUnableEnvelopeFurtherActionsModal.vue';
import DocumentBadgeSelector from '@/modules/business/components/molecules/DocumentBadgeSelector.vue';
import SignaturesSummaryBadge from '@/modules/business/components/molecules/SignaturesSummaryBadge.vue';
import ShowSignaturePdfAWhenAlreadySignedDocumentsFailureModal from '@/modules/business/components/organisms/modals/ShowSignaturePdfAWhenAlreadySignedDocumentsFailureModal.vue';

export default {
  name: 'EnvelopeViewerPage',
  components: {
    ShowUnableEnvelopeFurtherActionsModal,
    DocumentsViewer,
    ShowEnvelopeInfoModal,
    ShowEnvelopeDoneModal,
    Icon,
    BottomAction,
    ShowSignatureFailureModal,
    ShowEnvelopeSignerDoneModal,
    ShowRequestSignatureSentModal,
    ShowSignaturePdfAWhenAlreadySignedDocumentsFailureModal,
    ApproveEnvelopeModal,
    ApproveEnvelopeDoneModal,
    SignaturesListDropdown,
    DocumentBadgeSelector,
    SignaturesSummaryBadge,
  },
  props: {
    noTitleBackButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      documentLoaded: false,
      payload: null,
      isReady: false,
      isAllowed: false,
      signatures: {
        initial: '',
        signature: '',
      },
      addressee: null,
      recipientToken: '',
      emptyFields: [],
      blured: true,
      currentDocument: null,
    };
  },
  async created() {
    this.$loading(true);
    const self = this;
    const pageTitle = self.$t('receivedEnvelope');
    await this.$store.dispatch('page/setClass', 'envelope-viewer');
    await this.$store.dispatch('page/setTitle', pageTitle);
    const head = {
      title: pageTitle,
    };
    if (!this.noTitleBackButton) {
      head.action = function h() {
        let routeName = 'business.documents';
        if (self.isPublic) {
          routeName = 'public.checker';
        }
        self.$router.push({ name: routeName });
      };
    }
    await this.$store.dispatch('page/setHead', head);
    await this.getSignatures();
    await this.fetchEnvelope();
    this.recipientToken = this.$route.params.token;
    this.isReady = true;

    this.$nextTick(() => {
      this.$refs.showEnvelopeInfoModal.$refs.modal.open();
    });

    if (!this.isPublic && this.canActionEnvelope) {
      this.blured = false;
    }

    this.$loading(false);
  },
  computed: {
    isPublic() {
      return this.$route.name.split('.').shift() === 'public';
    },
    envelopeCanBeSigned() {
      return this.payload.envelope.state === EnvelopeState.IN_TRANSIT;
    },
    hideFormAcceptTerms() {
      return (
        !this.isPublic ||
        !this.envelopeCanBeSigned ||
        this.payload.state !== RecipientState.WAITING
      );
    },
    userCanSing() {
      return (
        this.payload.type === RecipientType.SIGNER &&
        this.payload.state === RecipientState.WAITING &&
        EnvelopeState.isOpened(this.payload.envelope.state)
      );
    },
    userCanApprove() {
      return (
        this.payload.type === RecipientType.APPROVER &&
        this.payload.state === RecipientState.WAITING &&
        EnvelopeState.isOpened(this.payload.envelope.state)
      );
    },
    userIsViewer() {
      return this.payload.state === RecipientState.FOLLOWING;
    },
    isAllowToDownloadSignaturePage() {
      return this.payload.envelope.state === EnvelopeState.COMPLETED;
    },
    hasLoggedUser() {
      return this.$root.user?.name !== '';
    },
    canActionEnvelope() {
      if (this.hasLoggedUser === false) {
        return true;
      }
      if (this.addressee?.via === 'email') {
        return this.addressee.value === this.$root.user.email;
      }
      if (this.addressee?.via !== 'email') {
        return this.addressee.value === this.$root.user.phone;
      }
      return false;
    },
    // hasFieldsToFill() {
    //   return this.getOnlyFieldElementsEmpty.some((e) => e.required);
    // },
    mySignaturesSummary() {
      const documents = this.payload?.envelope?.documents;
      if (!documents?.length) {
        return null;
      }
      const myRecipient = this.payload.envelope.recipients.find(
        (r) => r.id === this.payload.id
      );
      const isSignerType =
        myRecipient?.type === RecipientType.SIGNER ||
        myRecipient?.type === RecipientType.IN_PERSON_SIGNER;
      if (!isSignerType) {
        return null;
      }
      const excludeDocuments = myRecipient?.exclude_documents ?? [];
      const total = documents.length;
      const count = documents.filter(
        (doc) => !excludeDocuments.includes(doc.id)
      ).length;
      return { count, total };
    },
  },
  methods: {
    async fetchEnvelope() {
      try {
        RecipientsService.supressDefault = true;
        const res = await RecipientsService.listEspecificRecipientEnvelope(
          this.$route.params.token
        );
        this.processEnvelope(res);
        this.processRecipientToAction(res);
      } catch (error) {
        if (error.response.status === 400) {
          alert.fireAlert(this.$t('modal.envelope.invalidToken'), {
            classes: 'alert-danger',
            styles:
              'background-color: #f8d7da; border-color: #F5C6CB; color: #721C24;',
            tag: 'httpAlert',
            icon: 'triangle-exclamation',
          });
          this.$router.replace({ path: '/not-found' });
        }
      } finally {
        RecipientsService.supressDefault = false;
      }
    },
    processRecipientToAction(res) {
      this.payload = res.data;
      this.addressee = {
        id: this.payload.id,
        actionToken: this.payload.action_token,
        name: this.payload.name,
        via: this.payload.via,
        value: this.payload.value,
        type: this.payload.type,
        routingOrder: this.payload.routing_order,
        state: this.payload.state,
        notifiedAt: this.payload.notified_at,
      };
    },
    processEnvelope(res) {
      if (res.headers['x-workspace']) {
        this.$emit('customWorkspaceId', res.headers['x-workspace']);
      }
      this.payload = res.data;
      this.payload.envelope.documents = res.data.envelope.documents.map(
        (doc) => {
          const document = doc;
          document.src = document.links.display;
          // eslint-disable-next-line max-len
          document.elements = EnvelopeManager.extratElementsFromDocument(
            document,
            this.payload.envelope.recipients,
            this.signatures,
            this.payload.value,
            this.payload.state
          );
          return document;
        }
      );
      const previousDocumentId = this.currentDocument?.id;
      this.currentDocument = previousDocumentId
        ? this.payload.envelope.documents.find(
            (d) => d.id === previousDocumentId
          ) || this.payload.envelope.documents[0]
        : this.payload.envelope.documents[0];
    },
    async signed(response) {
      try {
        this.$refs.bottomAction?.initLoading?.();
        if (response.status === 202) {
          await this.fetchEnvelope();
          this.$refs.showRequestSignatureSentModal.$refs.modal.open();
          return;
        }
        await this.getSignatures();
        this.processEnvelope(response);

        if (
          this.payload.type === RecipientType.APPROVER &&
          this.payload.envelope.state !== EnvelopeState.COMPLETED
        ) {
          this.$refs.approveEnvelopeModal.$refs.modal.open();
          return;
        }

        if (this.payload.type === RecipientType.APPROVER) {
          this.$refs.approveEnvelopeDoneModal.$refs.modal.open();
          return;
        }

        if (
          this.payload.type === RecipientType.SIGNER &&
          this.payload.envelope.state !== EnvelopeState.COMPLETED
        ) {
          this.$refs.showEnvelopeSignerDoneModal.$refs.modal.open();
          return;
        }
        this.$refs.showEnvelopeDoneModal.$refs.modal.open();
      } finally {
        this.offLoading();
      }
    },
    signatureFailure() {
      this.$refs.showSignatureFailureModal.$refs.modal.open();
      this.offLoading();
    },
    signaturePdfAWhenAlreadySignedDocumentsFailure() {
      this.$refs.showSignaturePdfAWhenAlreadySignedDocumentsFailureModal.$refs.modal.open();
      this.offLoading();
    },
    async unableEnvelopeFurtherActions() {
      this.$refs.ShowUnableEnvelopeFurtherActionsModal.$refs.modal.open();
      this.offLoading();
    },
    offLoading() {
      if (this.$loading) {
        return this.$loading(false);
      }
    },
    rejected(response) {
      this.processEnvelope(response);
    },
    canceled(response) {
      this.processEnvelope(response);
    },
    markAsAllowed() {
      this.blured = false;
      this.isAllowed = true;
    },
    checkIfIsAllowed() {
      if (!this.isAllowed) {
        this.$refs.showEnvelopeInfoModal.$refs.modal.open();
      }
    },
    onElementUpdate(element) {
      RecipientsService.fillField(
        this.$route.params.token,
        element.id,
        element.value
      );
    },
    async onSignatureUpdate(signature, element) {
      this.$loading(true);
      await SignatureHttp.savePublicSignature(
        this.$route.params.token,
        element.type,
        signature.blob
      )
        .then(async () => {
          await RecipientsService.fillField(
            this.$route.params.token,
            element.id,
            signature.image
          );
        })
        .finally(() => this.$loading(false));
    },
    async getSignatures() {
      this.signatures.initial = await SignatureHttp.getPublicSignature(
        this.$route.params.token,
        'initial'
      );
      this.signatures.signature = await SignatureHttp.getPublicSignature(
        this.$route.params.token,
        'signature'
      );
    },
  },
};
</script>
<style lang="stylus">
.envelope-viewer--screen
  .blured
    .pdf-page
      filter: blur(6px)
  .pdf-render.loading
    top: 1.7rem
  .view__actions
    margin-bottom: 1rem
    text-align: right
  .viewer
    order: 2
  .documents-section-title
    display: flex
    align-items: center
    gap: 0.5rem
    margin-bottom: 0.75rem
    font-weight: 600
  .pdf-pages, .pdf-thumbs
    max-height: calc(100vh - 240px)
    scroll-behavior: smooth
  .recipients-list
    order: 1
  .actions-bar
    order: 3
    display: none
    &.loaded
      display: block
@media(min-width: 992px)
  .envelope-viewer--screen
    .viewer
      order: 1
    .recipients-list
      order: 2
</style>
